<app-wizard-modal [vertical]="true"
                  [isLoading]="isLoading"
                  (stepChange)="onStepChange($event)"
                  (cancel)="onWizardCancel()"
                  (submit)="onWizardSubmit()">
    <app-wizard-title>{{ 'admin.tools.batchUpdate.form.title' | translate }}</app-wizard-title>
    <app-wizard-step [canContinue]="toolPropertiesValid">
        <ng-template #title>{{ 'admin.tools.batchUpdate.form.step1.title' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <app-tool-responsible-form
                [showValidations]="step.nextTriggered">
            </app-tool-responsible-form>
        </ng-template>
    </app-wizard-step>
    <app-wizard-step>
        <ng-template #title>{{ 'admin.tools.batchUpdate.form.overview.title' | translate }}</ng-template>
        <ng-template #content
                     let-step="step">
            <div class="overview">
                <div class="changes">
                    <div class="title">
                        {{ 'admin.tools.batchUpdate.form.overview.changes' | translate }}
                    </div>
                    <div *ngIf="hasChanges" class="body">
                        <span *ngIf="ownerProp">{{ 'admin.tools.form.labels.owner.label' | translate }}
                            : {{ this.ownerProp }} </span>
                        <span *ngIf="prodValidityProp">
                            <div> {{ 'admin.tools.batchUpdate.form.properties.productionAvailability.label' | translate }}
                                : {{ this.prodValidityText }}
                            </div>
                            <div> {{ 'admin.tools.batchUpdate.form.properties.productionAvailability.reason.label' | translate }}
                                : {{ this.prodValidityReason }}
                                </div>
                        </span>
                    </div>
                    <div *ngIf="!hasChanges" class="empty">
                        {{ 'admin.tools.batchUpdate.form.overview.empty' | translate }}
                    </div>
                </div>
                <app-alert *ngIf="hasChanges" type="info"
                           [message]=infoMessage
                           [responsive]="true">
                </app-alert>
                <app-tool-scan-tree mode="display" [items]="selectedTools">

                </app-tool-scan-tree>
            </div>
        </ng-template>
    </app-wizard-step>
</app-wizard-modal>
